import {Draggable, Flip, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameMars} from "../base/BaseGameMars";
import {Gradient} from "../survey/Gradient";
import {Chatroom} from "../survey/Chatroom";

// Constructor
export class Survey extends BaseGameMars {

  constructor() {
    super(`data/survey.json`, 'survey');
    gsap.registerPlugin(Draggable, InertiaPlugin, Flip);

    this.timeline = gsap.timeline();
  }

  initGame() {

    // Audio example
    // setInterval(() => app.audio.play("audio/click.wav", 1, true), 1000)

    this.updateTime();
    this.clockInterval = setInterval(() => this.updateTime(), 1000);

    this.gradient = new Gradient($("#background-gradient"));
    this.gradient.followCirclePath(110, 8);
    this.chatroom = new Chatroom($(".chatroom-wrapper"), this.data.content.keyboard.reactions, this.addScore.bind(this));

    // Build score object
    this.sectorsResults = {}
    Object.keys(this.data.content.screen4.results_sector).forEach(key => {
      this.sectorsResults[key] = 0;
    })

    super.initGame();
  }

  initScreen(screenId) {
    const targetScreenNoSuffix = parseInt(screenId.toString().split("-")[0]);

    if (targetScreenNoSuffix === 2) {


    } else if (targetScreenNoSuffix === 3) {
      this.timeline.to("body", {
        backgroundColor: "#242626",
        duration: 1,
        ease: "power2.inOut"
      });

      this.timeline.fromTo("#chat-wrapper", {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut"
      }, '<')

      this.chatroom.$keyboard.addClass("visible");

      const $lastBtn = $(".chat-choice-btn").last();
      $lastBtn.one("transitionend", () => {
        this.chatroom.$keyboard.addClass("entered");
      });

      const steps = [];
      for (let [index, group] of Object.entries(this.data.content.chatroom.steps_group)) {

        // For sector questions, randomize sector questions but keep strict order for the other one
        if (group.name === "questions") {
          const withSector = group.substeps.filter(s => s.sector !== undefined && s.sector !== null);
          const shuffledSector = withSector.sort(() => Math.random() - 0.5);
          for (let step of group.substeps) {
            if (step.sector !== undefined && step.sector !== null) steps.push(shuffledSector.shift());
            else steps.push(step);

            // DEBUG UTILITY: Only keep one question for debug
            // if (steps.length > 5) break;
          }

        } else {
          steps.push(...group.substeps);
        }
      }

      console.log("Randomized steps:", steps)

      setTimeout(() => this.chatroom.runSteps(steps), 2500);

    } else if (targetScreenNoSuffix === 4) {
      this.timeline.to("body", {
        backgroundColor: "#242626",
        duration: 1,
        ease: "power2.inOut"
      });

      this.gradient.goToCenter();

      this.resultsPending();
    }
  }

  resultsPending() {
    const $results = $(".result-pending");
    $($results[1]).append('<img class="icon" src="images/survey/exclamation.png">');

    this.timeline.fromTo($results[0],
      {
        opacity: 0,
        visibility: "hidden"
      },
      {
        opacity: 1,
        duration: 1,
        visibility: "visible",
        ease: "power2.inOut"
      }
    );

    this.timeline.add(() => {
      this.timeline.fromTo($results[1],
        {
          opacity: 0,
          visibility: "hidden"
        },
        {
          opacity: 1,
          visibility: "visible",
          duration: 1,
          ease: "power2.inOut"
        });

      this.timeline.to($($results[0]), {
        opacity: 0,
        duration: 0.4,
        ease: "power2.inOut"
      });

      this.timeline.fromTo($($results[1]).find('.robot'),
        {
          opacity: 0,
          y: 50,
          scale: 0.8,
          visibility: "visible"
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: "back.inOut(3)"
        }, '<');

      this.timeline.fromTo($($results[1]).find('.icon'),
        {
          opacity: 0,
          scale: 0.7,
          visibility: "visible"
        },
        {
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: "back.inOut(5)"
        }, '-=0.4');

      this.timeline.fromTo($($results[1]).find('.message1'),
        {
          opacity: 0,
          y: 100,
          scale: 0.6,
          visibility: "visible"
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          ease: "back.inOut(3)"
        }, '<');

      this.timeline.to($(".thinking-animation"), {
        opacity: 0,
        duration: 0.1,
        ease: "power2.inOut"
      }, '<');

      this.timeline
        .to($($results[1]).find('.robot, .icon'), {
          opacity: 0,
        }, '+=1')
        .set($($results[1]).find('.robot'), {
          attr: {src: "images/survey/Mars-E-result.png"},
          className: "new-robot"
        })
        .to($($results[1]).find('.robot'), {
          opacity: 1,
          duration: 0.8,
        });

      this.timeline.fromTo($($results[1]).find('.message2'),
        {
          opacity: 0,
          y: 100,
          scale: 0.8,
          visibility: "visible"
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          ease: "back.inOut(3)"
        }, '-=1.2');

      this.timeline.add(() => {
        this.showResults()
      }, '+=2.5')

    }, '+=1')
  }

  addScore(sector, score) {
    this.sectorsResults[sector] += score;
  }

  getWinningSector() {
    // Determine the highest score
    const maxScore = Math.max(...Object.values(this.sectorsResults));

    // Collect all sectors that have this score
    const winningSectors = Object.entries(this.sectorsResults)
      .filter(([, score]) => score === maxScore)
      .map(([sector]) => sector);

    // Return a random sector among the winners (or null if none)
    return winningSectors.length
      ? winningSectors[Math.floor(Math.random() * winningSectors.length)]
      : 'sector1';
  }

  showResults() {
    const winningSector = this.getWinningSector();
    console.log("Winning sector:", winningSector)

    this.timeline.add(() => {
      setTimeout(function () {
        $("#result-overlay").addClass("shown");
        $(`#result-overlay .overlay`).removeClass("shown");
        $(`#result-overlay .${winningSector}`).addClass("shown");
      }, 1000)
    }, '+=0.5')
  }

  resetResults() {
    $(".result-pending .icon").remove();
    $("#result-overlay").removeClass("shown");
    $(`#result-overlay .overlay`).removeClass("shown");

    // Reset score
    Object.keys(this.sectorsResults).forEach(key => {
      this.sectorsResults[key] = 0;
    })
  }

  updateTime() {
    const now = new Date();
    let h = now.getHours();
    const m = now.getMinutes().toString().padStart(2, '0');
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    h = h ? h : 12;
    $(".time-chat .time").text(h + ':' + m + ' ' + ampm);
  }

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  beforeGoToScreen() {
    this.chatroom.reset();
    this.gradient.goToBottom();

    this.resetResults();

    this.timeline.restart();
    this.killTimeline(this.timeline);
    this.timeline = gsap.timeline();

    this.wait(800).then(() => {
      app.goToScreen(3);
    })
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {

    if (this.clockInterval) {
      clearInterval(this.clockInterval);
      this.clockInterval = null;
    }

    // Reset variable and timeline
    this.timeline.restart();
    this.killTimeline(this.timeline);
    this.timeline = gsap.timeline();

    const resetCallback = () => {
      this.chatroom.reset()
      this.gradient.reset();
      this.resetResults();
    }

    // Super
    return super.reset(screenId, resetCallback);
  }

}
